<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <div class="ChapterSlide">
            <main class="ChapterSlide-main">
                <div class="ChapterSlide-container" ref="container">
                    <chapter-index
                        v-show="visible"
                        :index="index"
                        :total="total"
                    ></chapter-index>

                    <transition name="fade">
                        <h1 class="ChapterSlide-title" v-show="visible">
                            {{ chapter.name }}
                        </h1>
                    </transition>

                    <div class="ChapterSlide-subtitle">
                        <div
                            class="ChapterSlide-separator"
                            ref="separator"
                        ></div>
                        <transition name="fade">
                            <h2 class="small" v-show="visible">
                                {{chapter.profession}}
                            </h2>
                        </transition>
                    </div>

                    <transition name="fade">
                        <div
                            class="ChapterSlide-description"
                            v-show="visible"
                            v-html="chapter.description"
                        ></div>
                    </transition>
                </div>
            </main>
            <div class="ChapterSlide-nav">
                <round-bttn
                    v-if="chapter.hasVideo"
                    v-show="visible"
                    :icon="lineIcons.videoCamera"
                    :to="videoTo"
                >
                    <small>Ver capítulo</small>
                </round-bttn>
                <round-bttn
                    v-show="visible"
                    :icon="lineIcons.notebook"
                    :to="noteboookTo"
                >
                    <small>Ver libreta</small>
                </round-bttn>
            </div>
        </div>
    </transition>
</template>

<script>
    import * as routes from '@/app/routes'
    import TextTransition from '../transitions/TextTransition'
    import ChapterIndex from './ChapterIndex'
    import RoundBttn from './RoundBttn'

    export default {
        name: 'ChapterSlide',
        props: {
            index: {
                type: Number,
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
            chapter: {
                type: Object,
                required: true,
            },
        },
        components: {
            TextTransition,
            ChapterIndex,
            RoundBttn,
        },
        data() {
            return {
                visible: false,
            }
        },
        methods: {
            intro(el, done) {
                const {$refs} = this
                this.visible = true
                TweenLite.set($refs.container, {x: 0})
                TweenLite.set($refs.separator, {alpha: 1, width: 0})
                TweenLite.to($refs.separator, 0.6, {width: 75, delay: 1.2})
                done()
            },
            outro(el, done) {
                const {$refs} = this
                this.visible = false
                TweenLite.to($refs.container, 1, {
                    x: -10,
                    ease: Cubic.easeOut,
                })
                TweenLite.to($refs.separator, 0.3, {
                    alpha: 0,
                    ease: Cubic.easeOut,
                })
                done()
            },
        },
        computed: {
            lineIcons() {
                const {$store} = this
                return $store.getters.data.lineIcons
            },
            videoTo() {
                const {chapter} = this
                return {
                    name: routes.CHAPTER_VIDEO,
                    params: {
                        id: chapter.id,
                    },
                }
            },
            noteboookTo() {
                const {chapter} = this
                return {
                    name: routes.CHAPTER_ART,
                    params: {
                        id: chapter.id,
                    },
                }
            },
        },
    }
</script>

<style src="styles/components/ChapterSlide.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/ChapterSlide.vue